












































































import Vue from 'vue';
import { Component, Prop, Emit, Watch, Ref, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Viewpoints from '@/store/modules/Viewpoints';
import BarChart from '@/components/chart/BarChart.vue';
import FactorImportanceChart from '@/components/chart/FactorImportantceChart.vue';
import ScatterChart from '@/components/chart/ScatterChart.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Modelling from '@/store/modules/Modelling';
import FactorNavigationPublishedModel from '@/components/navigation/FactorNavigationPublishedModel.vue';
import { CHART_TYPES, CHART_TYPE_NAMES } from '@/utils/ChartTypes';
import { FactorGroup } from '@/api/model/FactorResource';
import Scoring from '@/store/modules/Scoring';

const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        CardTitle,
        BarChart,
        ScatterChart,
        FactorNavigationPublishedModel,
        FactorImportanceChart,
    },
})
export default class ChartDialog extends Vue {
    private open = false;
    private res: any = null;
    private selectedChart = '';
    private selectedFactorIds: string[] = [];
    private isloading: boolean = false;
    private dataIsLoaded: boolean = false;
    private alertType: string = 'success';
    private alertText: string = '';
    private showAlert: boolean = false;
    private items = CHART_TYPES;
    private CHART_TYPE_NAMES = CHART_TYPE_NAMES;

    private functionMapper = {
        [CHART_TYPE_NAMES.STACKED_BAR_FACTOR_SCORES]: this.getBarChart,
        [CHART_TYPE_NAMES.SCATTER_TWO_FACTOR_COMPARISON]: this.getScatterChart,
       // [CHART_TYPE_NAMES.BAR_FACTOR_IMPORTANCE]: this.getBarFactorImportanceChart,
    };

    // @PropSync('series', {default: () => ({}), type: Object})
    // seriesSync!: any;
    private chartData: any = {
        data: {
            series: [],
        },
        title: {
            text: '',
        },
        xaxis: {
            categories: [],
        },
    };

    @Watch('selectedChart')
    private onChangeSelectedChart() {
        this.chartData = {};
        this.dataIsLoaded = false;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get viewpointId() {
        return viewpointsModule.activeViewpointId;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }
    get factorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree('M');
        }
    }

    get selectedFactor() {
        if (this.factorResources && this.selectedFactorResourceItemId) {
            return this.factorResources[this.selectedFactorResourceItemId];
        } else {
            return null;
        }
    }

    get selectedViewpointIds() {
        return viewpointsModule.selectedViewpointIds;
    }

    get contributingFactors() {
        return viewpointsModule.contributingFactorResources;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }
    @Watch('selections')
    private onChangeCheckableFactors(value: string[]) {
        if (value.length > 2) {
            let i = 0;
            for (i = 0; i < value.length - 2; i++) {
                value.shift();
            }
        }
        this.selectedFactorIds = value;
    }

    private async submit() {
        if (this.selectedChart !== '') {
            this.isloading = true;
            this.functionMapper[this.selectedChart]();
            console.log("this.functionMapper[this.selectedChart]()", this.functionMapper[this.selectedChart]());
        }
    }

    private async getBarChart() {
        try {
            let factorIds = [];
            if (this.selectedFactor && this.viewpointId) {
                if (this.selectedFactor.childrenIds && this.selectedFactor.childrenIds.length > 0) {
                    factorIds = this.selectedFactor.childrenIds;
                } else {
                    factorIds = [this.selectedFactor.id];
                }                
                this.res = await getModule(Scoring).getStackedBarChartDataChoiceTab({decisionId:this.decisionId, viewpointId: this.viewpointId, factorIds: factorIds, factorParentId: this.selectedFactor.id})  
                console.log("this.res", this.res)
                this.chartData = this.res;
                this.dataIsLoaded = true;
                this.successMsg('Success!');
            } else {
                if (!this.viewpointId) {
                    this.errorMsg('Please Select a Viewpoint');
                }else if(!this.selectedFactor){
                    this.errorMsg('Please Select a Factor');
                }
            }
        } catch (error) {
            this.errorMsg('Error - Can not get chart data');
        }
        this.isloading = false;
    }

    private async getScatterChart() {
        try {
            if (this.decisionId && this.viewpointId && this.selectedFactorIds.length === 2) {
                console.log("scatter chart not developed yet")
                // this.res = getModule(Scoring).getScatterChartData({tab:"notSure", decisionId: this.decisionId, viewpointIds: [this.viewpointId]})  // await VIEWPOINT_API.generateStackedBarChart(this.decisionId,[this.viewpointId], this.selectedFactorIds);
                // this.chartData = this.res[this.viewpointId];
                // this.dataIsLoaded = true;
                // this.successMsg('Success!');
            } else {
                if (this.selectedFactorIds.length !== 2) {
                    this.errorMsg('Please Select Exactly 2 Factors');
                } else if (!this.viewpointId) {
                    this.errorMsg('Please Select a Viewpoint');
                }
            }
        } catch (error) {
            this.errorMsg('Error - Can not get chart data');
        }
        this.isloading = false;
    }
    private factorPaths: any;

    private getFactorPath(selectedFactorIds: any) {
        let factorPaths = {};
        selectedFactorIds.forEach((e) => {
            factorPaths[e] = [];
            this.findPath(this.factorResourceTree, e, factorPaths[e]);
        });
        this.factorPaths = factorPaths;
        return factorPaths;
    }

    // private async getBarFactorImportanceChart() {
    //     try {
    //         if (this.decisionId && this.viewpointId) {
    //             const factor = this.factors[this.factorId];

    //             const viewpointIds = [this.currentViewpointId];
    //             const res = await getModule(Scoring).getFactorImportanceChart({decisionId: this.decisionId, viewpointIds: viewpointIds, factorIds: factor.childrenIds});

    //             this.chartData = res[this.currentViewpointId]
    //             this.dataIsLoaded = true;
    //             this.successMsg('Success!');
    //         }else if(!this.viewpointId){
    //             this.errorMsg('Please Select a Viewpoiont');
    //         }
    //     } catch (error) {
    //         this.errorMsg('Error - Can not get chart data');
    //     }
    //     this.isloading = false;
    // }

    private successMsg(msg: string) {
        this.alertType = 'success';
        this.alertText = msg;
        this.showAlert = true;
        if (this.showAlert) {
            setTimeout(() => (this.showAlert = false), 2000);
        }
    }
    private errorMsg(msg: string) {
        this.alertType = 'error';
        this.alertText = msg;
        this.showAlert = true;
        if (this.showAlert) {
            setTimeout(() => (this.showAlert = false), 2000);
        }
    }

    private cancel() {
        this.open = false;
        this.dataIsLoaded = false;

        this.chartData = {
            data: {
                series: [],
            },
            title: {
                text: '',
            },
            xaxis: {
                categories: [],
            },
        };
        this.selectedChart = '';
    }

    private getSubTree(factorResourceId: string): { id: string; name?: string; children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition &&
            (factorGroup.groupTypeDefinition.type === 'TABLE_FIXED' ||
                factorGroup.groupTypeDefinition.type === 'TABLE_GROWING')
        ) {
            childrenIds = factorGroup.childrenIds
                .map((f) => this.factorResources[f])
                .filter((f) => f)
                .filter(
                    (f) =>
                        f.type === 'FACTOR_GROUP' &&
                        (f as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN'
                )
                .map((f) => f.id); // This will update the factor names to display correctly
            let rows = factorGroup.childrenIds
                .map((f) => this.factorResources[f])
                .filter((f) => f) // contributing
                .filter(
                    (f) =>
                        f.type === 'FACTOR_GROUP' &&
                        (f as FactorGroup).groupTypeDefinition.type === 'TABLE_ROW'
                ) as FactorGroup[];
            for (let colId of childrenIds) {
                let column = this.factorResources[colId] as FactorGroup;
                if (!column) continue;
                column.childrenIds.forEach((id) => {
                    let row = rows.find((r) => r.childrenIds.includes(id));
                    if (row && this.factorResources[id]) {
                        this.factorResources[id].name = row.name;
                    }
                });
            }
        } else {
            childrenIds = factorGroup.childrenIds || [];
        }
        let children = childrenIds
            .filter((id) => this.contributingVisibility || this.contributingFactors[id])
            .filter((f) => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name,
                    };
                }
                return this.getSubTree(cId);
            });
        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children,
        };
    }

    /* function findPath - find all the branches and nodes store into an array
    // @param - tree, original tree 
    // @param - filter, tree node 
    // @param - treeNodes, array of tree nodes
    */
    private findPath(tree: any, filter: string, treeNodes: any) {
        // if it's an object, go through the children first
        // if it's array, loop through the array
        if (!Array.isArray(tree) && typeof tree === 'object') {
            // check if current object matches the fitler, if match add to the treenodes and return true
            if (tree.id === filter) {
                treeNodes.push(tree.id);
                return true;
            } else if (
                tree.hasOwnProperty('children') &&
                tree.children &&
                tree.children.length > 0
            ) {
                // loop through children, call this function for all the children
                let foundInChildren = false; // value for storing if the node has been found in the children
                tree.children.forEach((child: any) => {
                    // call the function itself to iterate the chidren
                    // if found, store the result in foundInChildren
                    if (this.findPath(child, filter, treeNodes)) {
                        foundInChildren = true;
                    }
                });
                // if children found the id, store the parent id and return true;
                if (foundInChildren) {
                    treeNodes.push(tree.id);
                    return true;
                } else {
                    return false;
                }
            } else {
                // if the current "tree" is an object id !== filter and it doesn't have children, return false
                return false;
            }
            // else if the object is array, call the function itself to iterate through the array
        } else if (Array.isArray(tree)) {
            for (let child of tree) {
                this.findPath(tree, filter, treeNodes);
            }
        } // console.log(filteredTree);
    }
}
